import { render, staticRenderFns } from "./RadioCheckboxWithIcon.vue?vue&type=template&id=01a7c615&lang=pug&"
import script from "./RadioCheckboxWithIcon.vue?vue&type=script&lang=ts&"
export * from "./RadioCheckboxWithIcon.vue?vue&type=script&lang=ts&"
import style0 from "./RadioCheckboxWithIcon.vue?vue&type=style&index=0&id=01a7c615&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports